module.exports = " <section v-show=item.selected> <p><b>Адрес:</b> {{item.object.display_name | fallback}}</p> <p><b>Положение:</b> {{item.object.position.lat }}, {{item.object.position.lon}}</p> </section> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/templates/SputnikShape.vue
// module id = 211
// module chunks = 0